import React, {useEffect, useState} from 'react';


import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';
import {getStatsigKey} from 'src/openapi/admin/apis/ClientConfigApi';
import {getAdminShortInfo} from 'src/openapi/admin/apis/GetAdminShortInfoApi';
import {useAppDispatch} from 'src/store/hooks';

import Loading from '@pb/kit-component-loading';
import Statsig from '@pb/kit-lib-statsig';

import type {InitializeResponseWithUpdates} from '@statsig/client-core';
import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    children: React.ReactNode,
};

export const StatsigContextProvider = ({children}: Props) => {
    const apiDispatch = useAppDispatch();

    const [isLoading, setIsLoading] = useState(true);
    const [serverError, setServerError] = useState<Error | null>(null);

    useEffect(() => {
        const loadConfig = async () => {
            setIsLoading(true);
            const userResponse = await apiDispatch(getAdminShortInfo());

            if (userResponse.payload.success) {
                const adminId = userResponse.payload.data.userId;

                const statsigConfigResponse = await apiDispatch(getStatsigKey({adminId}));
                if (statsigConfigResponse.payload.success) {
                    const {sdkKey, env, initializeValues} = statsigConfigResponse.payload.data;

                    Statsig.initializeSync({
                        sdkKey,
                        initializeValues: initializeValues as InitializeResponseWithUpdates,
                        user: {
                            userID: adminId.toString(),
                            email: userResponse.payload.data.email,
                        },
                        options: {environment: {tier: env}},
                    });
                    setIsLoading(false);
                } else {
                    setServerError(statsigConfigResponse.payload.data);
                    setIsLoading(false);
                }
            } else {
                setServerError(userResponse.payload.data);
                setIsLoading(false);
            }
        };

        loadConfig();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Skeleton shown={isLoading} view={<Loading fast={true}/>}>
            <ServerResponseHandler serverError={serverError}>
                <div>
                    {children}
                </div>
            </ServerResponseHandler>
        </Skeleton>
    );
};
